<script>
    import { updateData } from '../data/updateData.js';
    import { mainData } from '../stores.js';

</script>


<section data-step="4" class="step">
    <div class="newchapter">
        <h1 class="chapter">IV.  Wat is <i class="mark">Jouw</i> Schuld?!</h1>
        <h2 class="chaptersubtitle">Leuk, maar wat heeft dit met jou te maken?!</h2>
    </div>

    <div class="row">
        <div class="twelve columns">
            <h2>Jouw Schuld</h2>
            <p>Deze site is interactief! Wil je zien hoe jouw studiefinanciering is verlopen? Vul hieronder jouw studieschuld in (en wanneer je gestart bent), en de grafieken passen zich automatisch aan op jouw situatie.                     </p>
            <p>Nu gaan we door met de belangrijke getallen! Je kunt deze getallen allemaal in 'Mijn DUO' vinden. Of klik op 'gebruik gemiddelde' om zonder je eigen getallen verder te gaan.</p>

        </div>
    </div>

    <div class="row form">
        <div class="six columns">
            <div class="row">
                <label for="beginmaand">Wanneer ben je begonnen met je studie?</label>
                <input name="beginmaand"type="date" bind:value={$mainData.beginMaand}>
            </div>
            <div class="row ">
                <label for="eindmaand">Wanneer ga je stoppen/ben je gestopt met lenen?</label>
                <input name="eindmaand" type="date" bind:value={$mainData.eindMaand}>
            </div>
            <div class="row ">
                <label for="sector">In welke sector verwacht je te gaan werken na je studie?</label>
                    <select id="cars" name="sector">
                        <option value="volvo">Overheid</option>
                        <option value="saab">Onderwijs</option>
                        <option value="fiat">Rechten</option>
                        <option value="audi">Medicijnen</option>
                    </select>
            </div>
        </div>
        <div class="six columns">
            <div class="row">
                <label for="collegegeld">Hoeveel schuld aan <b>Collegegeldkrediet</b> heb je tot nu toe opgebouwd??</label>
                <input name="collegegeld" type="number" bind:value={$mainData.collegegeld} >
            </div>
            <div class="row">
                <label for="reisproduct">Hoeveel schuld aan <b>Studentenreisproduct</b> heb je tot nu toe opgebouwd?</label>
                <input name="reisproduct" type="number" bind:value={$mainData.reisproduct}>
            </div>
            <div class="row">
                <label for="lening">Hoeveel schuld aan <b>Lening</b> heb je tot nu toe opgebouwd?</label>
                <input name="lening" type="number" bind:value={$mainData.lening}>
            </div>
            <div class="row">
                <label for="aanvullend">Hoeveel schuld aan <b>Aanvullende beurs</b> heb je tot nu toe opgebouwd?</label>
                <input name="aanvullend" type="number" bind:value={$mainData.aanvullend}>
            </div>
    </div>
</div>
<div class="row form">
    <div class="twelve columns center">
        <button class="center" on:click={updateData}>Update Getallen</button>
        <span>of ga verder zonder je eigen schuld in te vullen.</span>
    </div>
</div>
<div class="row request">
    <div class="twelve columns">
        <h2>Vraagje tussendoor...</h2>
        <p>Mag ik jouw informatie gebruiken om een gemiddelde te laten zien van mensen die deze site gebruiken?</p>
        <p><small>Jouw ingevulde gegevens worden anoniem verstuurd en zijn dan niet meer te herleiden naar jou.</small>                    </p>
        <button class="confirm">😄 Ja hoor!</button> <button class="deny">🙄 Nee, liever niet.</button>
    </div>
</div>

<div class="row ">
    <div class="twelve columns">
        <h2>Ready? Set? Rekenen maar!</h2>
        <p>Super! 🤩  We gaan nu dezelfde stappen langs als net met de uitleg, maar dan met <b>jouw</b> getallen. Ondertussen gaan we dieper in op hoe de spelregels precies voor jou werken.</p>    
    </div>
</div>

</section>